// ==============================|| OVERRIDES - FAB ||============================== //

export default function Fab(theme) {
	return {
		MuiFab: {
			styleOverrides: {}
		}
	}
}
